import {
	Component,
	Input,
	OnDestroy,
	ViewChild,
	ElementRef,
	EventEmitter,
	Output,
	ViewEncapsulation,
	SimpleChanges,
	forwardRef,
	OnChanges
} from "@angular/core";
import { IdService } from "../shared/services/id.service";
import { FormControlBase } from "../shared/classes/form-control-base";
import { ISwitchState } from "./switch.types";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { fromEvent, Observable } from "rxjs";
import { take } from "rxjs/operators";

@Component({
	selector: "rbc-switch",
	templateUrl: "./switch.component.html",
	styles: [],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => SwitchComponent)
		}
	]
})
export class SwitchComponent implements ControlValueAccessor, OnDestroy{
	@Input() id: string;
	@Input() disabled: string | boolean = false;
	@Input() disableEventBus = false;
	@Input() label: string;
	@Input() name: string;
	@Input() size: "small" | "medium" = "medium";
	@Input() value: boolean;
	@Input() ariaDescribedby: string;
	@Input() set checked(val){
		this._checked = val;
	};

	get checked(){
		return this._checked;
	}

	_checked: boolean;

	@Output() switchUpdate = new EventEmitter<ISwitchState>();


	@ViewChild("control", { static: false }) control: ElementRef;
	@ViewChild("formSwitchWrapper", { static: false })
	formSwitchWrapper: ElementRef;

	mouseoutObservable: Observable<any>;

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	// Function to call when the rating changes.
	change = (item) => {
		this.checked = item;
	}

	onTouched = () => { };
	writeValue(obj: any): void {
		this.checked = obj;
		this.switchUpdate.emit(obj);
	}
	registerOnChange(fn: any): void {
		this.change = fn;
	}
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	updateSwitch(newState) {
		// console.log(newState.target.checked)
		this.change(newState.target.checked)
		this.checked = newState.target.checked;
		this.switchUpdate.emit({ id: this.id, checked: newState.target.checked });

		// if (!this.mouseoutObservable) {
		// 	this.mouseoutObservable = fromEvent(
		// 		this.formSwitchWrapper.nativeElement,
		// 		"mouseout"
		// 	);

		// 	this.mouseoutObservable
		// 		.pipe(take(1))
		// 		.subscribe(this.removeFocus.bind(this));
		// }
	}

	removeFocus() {
		if (this.control) {
			this.control.nativeElement.blur();
			this.mouseoutObservable = null;
		}
	}

	get classGen() {
		let classes = {};
		classes["disabled"] = this.disabled;
		classes["rbc-switch-" + this.size] = this.size;

		return classes;
	}
}
